/**
 * `A` — the anchor the generated canvas sections render. Internal paths go
 * through next/link; in-page anchors and external URLs stay plain <a>. The
 * href has already been through the render-time gate (`L`) by the time it
 * reaches here, so every internal destination is a page that exists — and a
 * `null` href is the gate saying the page does not exist today (FRIDGE-798):
 * the whole tile is dropped, never rendered as a search link or a dead anchor.
 */
import Link from 'next/link'
import type { AnchorHTMLAttributes, ReactNode } from 'react'

type AProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & { href?: string | null; children?: ReactNode }

export function A({ href, children, ...rest }: AProps) {
  if (href === null) return null
  if (href && href.startsWith('/')) {
    return (
      <Link href={href} {...rest}>
        {children}
      </Link>
    )
  }
  return (
    <a href={href} {...rest}>
      {children}
    </a>
  )
}
